<template>
  <div class="vivo">
    <div class="header">
      <p>{{ app.header.tip1 }}</p>
    </div>
    <div class="container">
      <div class="container-title">
        <div class="num">1</div>
        <div class="title-word">{{ app.content.list1.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/vivo-1.png" alt="" />
        <img src="../assets/vivo-2.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">2</div>
        <div class="title-word">{{ app.content.list2.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/other-1.png" alt="" />
        <img src="../assets/other-2.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import zh from "@/locales/vivo/zh";
import en from "@/locales/vivo/en";
import { toggleLang } from "@/mixins/toggleLang";
export default {
  name: "vivo",
  mixins: [toggleLang],
  created() {
    this.toggle(zh, en);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
